import { injectable } from 'tsyringe'
import { TrainingMaterialReportApiRepository } from '@/app/repositories/api/TrainingMaterialReportApiRepository'
import {
  TrainingMaterialReport,
  Export,
} from '@/domain/entities/TrainingMaterialReport'

@injectable()
export class TrainingMaterialReportPresenter {
  private repository: TrainingMaterialReportApiRepository

  constructor(repository: TrainingMaterialReportApiRepository) {
    this.repository = repository
  }

  public loadTrainingMaterialReport(
    params: Object
  ): Promise<TrainingMaterialReport> {
    return this.repository.getAll(params)
  }
  public loadExport(params: Object): Promise<Export> {
    return this.repository.getExport(params)
  }
}
